<script setup lang="ts">
import { ref } from 'vue';

import { oidcClient } from '@/services/oidcClient';
import { BxButton } from '@beyonnex/bx-components-vue';

const isLoggingIn = ref(false);

const login = async () => {
  isLoggingIn.value = true;
  try {
    await oidcClient.signIn();
  } catch (error) {
    console.error('Login failed:', error);
  } finally {
    isLoggingIn.value = false;
  }
};
</script>

<template>
  <div class="mt-5 flex flex-col items-center justify-center gap-5">
    <BxButton
      :disabled="isLoggingIn"
      @click="login()"
    >
      {{ isLoggingIn ? 'Logging in...' : 'Login via SSO' }}
    </BxButton>
  </div>
</template>
